import { graphqlFetch } from '@pylot-data/graphqlFetch'
import { RelatedPostQuery } from '@pylot-data/hooks/blog/graphql/blogQuery'
import { AuthorTree, Maybe } from '@pylot-data/pylotschema'

export interface RelatedBlogPostParams {
    postId: string
}

export interface RelatedBlogPost {
    post_id: number
    meta_title: string
    meta_description: string
    title: string
    filtered_content: string
    author: RelatedPostAuthorDetail
    post_url: string
    creation_time: string
    modified_time: string
    publish_time: string
    categories: Array<RelatedPostCategoryDetail>
    related_posts: Array<RelatedPostDetails>
}

export interface RelatedPostAuthorDetail {
    author_id: string
    name: string
    author_url: string
}

export interface RelatedPostCategoryDetail {
    category_id: string
    title: string
    category_url: string
}

export interface RelatedPostDetails {
    author: Maybe<AuthorTree>
    creation_time: string
    modified_time: string
    publish_time: string
    identifier: string
    featured_image: string
    featured_list_image: string
    post_id: string
    title: string
    post_url: string
}

export type BlogRelatedPostResult = {
    blogPost: RelatedBlogPost
}

export type BlogRelatedPostVariables = {
    postId: string
}

export type GetBlogRelatedPostResult = BlogRelatedPostResult

async function getRelatedPost({
    postId,
    locale
}: {
    postId: string
    locale: string
}): Promise<GetBlogRelatedPostResult | undefined | null> {
    const blogDataPromise = graphqlFetch<
        BlogRelatedPostVariables,
        GetBlogRelatedPostResult
    >({
        query: RelatedPostQuery,
        variables: {
            postId: postId
        },
        locale
    })
    const [blogData] = await Promise.all([blogDataPromise])
    return {
        blogPost: blogData.data.blogPost
    }
}

export default getRelatedPost
